import {list} from "custom/demo/requests/admin/validation-automated-reports";
import AdminList from "custom/demo/helpers/admin/list";

const actions = {edit: true, list, new: true};

const columns = [
  {key: "active", label: "Active"},
  {key: "email", label: "Email"},
  {key: "file_url", label: "File"},
  {key: "name", label: "Name"},
  {key: "retest", label: "Retest"},
  {key: "study_name", label: "Study"}
];

export default function List() {
  return <AdminList actions={actions} columns={columns} name="Automated Report" path="/admin/validation/automated_reports" />;
}
